import React from 'react';

import BaseAppointment, { BaseAppointmentProps } from '~components/appointments/BaseAppointment';

type ConflictAppointmentProps = Omit<BaseAppointmentProps, 'layout' | 'className'>;

const ConflictAppointment: React.FC<ConflictAppointmentProps> = (props) => {
  return <BaseAppointment {...props} layout="date-first" className="conflict-appointment" />;
};

export default ConflictAppointment;
